var map = {
	"./commercial/0.jpg": 14,
	"./commercial/1.jpg": 15,
	"./commercial/2.jpg": 16,
	"./commercial/3.jpg": 17,
	"./commercial/4.jpg": 18,
	"./food/0.jpg": 19,
	"./food/1.jpg": 20,
	"./food/2.jpg": 21,
	"./food/3.jpg": 22,
	"./food/4.jpg": 23,
	"./landscape/0.jpg": 24,
	"./landscape/1.jpg": 25,
	"./landscape/2.jpg": 26,
	"./landscape/3.jpg": 27,
	"./landscape/4.jpg": 28,
	"./portraits/0.jpg": 29,
	"./portraits/1.jpg": 30,
	"./portraits/2.jpg": 31,
	"./portraits/3.jpg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;